import { render } from "./WeeklyTargetPolicy_status3.vue?vue&type=template&id=7275802e"
import script from "./WeeklyTargetPolicy_status3.vue?vue&type=script&lang=js"
export * from "./WeeklyTargetPolicy_status3.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__